/**
 * Fusionne la réponse serveur d’un autosave avec l’état local du dossier.
 * Évite d’écraser une saisie plus récente (ex. titre) pendant qu’une requête
 * plus ancienne est encore en vol, y compris un champ volontairement vidé.
 *
 * @param {Record<string, unknown>|null|undefined} prevDossier
 * @param {Record<string, unknown>|null|undefined} serverDossier
 * @param {Record<string, unknown>} payload Patch envoyé dans cette requête
 */
export function mergeDossierAfterSave(prevDossier, serverDossier, payload = {}) {
  if (!prevDossier) return serverDossier ?? null;
  if (!serverDossier) return prevDossier;

  const merged = { ...serverDossier };
  const keys = new Set([
    ...Object.keys(prevDossier),
    ...Object.keys(payload),
  ]);

  keys.forEach((key) => {
    if (key === 'id') return;

    if (Object.prototype.hasOwnProperty.call(payload, key)) {
      // Le local reste la source de vérité pour les champs de ce patch
      // (frappe en cours, ou champ vidé volontairement).
      merged[key] = prevDossier[key];
      return;
    }

    if (prevDossier[key] !== serverDossier[key]) {
      merged[key] = prevDossier[key];
    }
  });

  return merged;
}

export default mergeDossierAfterSave;
